import { all, fork } from 'redux-saga/effects'

import createLevelSaga from './createLevelSaga'
import updateLevelSaga from './updateLevelSaga'

export default function* levelsSaga() {
  yield all([fork(createLevelSaga), fork(updateLevelSaga)])
}
